<template>
  <v-container>
    <!--   Diálogo para Mostrar un mensaje al Eliminar Residente Principal     -->
    <v-dialog
        v-model="deleteDialog"
        persistent
        max-width="450"
    >
      <v-card>
        <v-card-title class="headline">
          {{$t('msg_eliminar_registros')}}
        </v-card-title>

        <v-card-text>
          {{$t('msg_accion_deshacer')}}
        </v-card-text>
        <v-card-actions>
          <v-btn
              :hidden="loading_si"
              color="primary"
              @click="deleteDialog = false"
          >
            No
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
              :loading="loading_si"
              color="primary"
              @click="deleteRecordsSelected()"
          >
            {{$t('Si')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout calign-center >
      <v-flex>
        <v-card class="elevation-5">
          <v-card-text>
            <v-layout calign-center>
              <v-flex>
                <v-card class="elevation-5">
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>
                      {{$t('historial_accesos_sin_codigo')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-card-text>
                    <v-layout row wrap class="my-4" align-center justify-center fill-height>
                      <h3>{{$t('mostrando_historial_dia')}} </h3>
                    </v-layout>
                    <v-form @submit.prevent="submit()">
                      <v-layout row wrap class="my-4" align-center justify-center fill-height>
                        <v-flex xs12 sm6 class="text-center">
                          <v-autocomplete
                              autofocus
                              v-model="id_empresa"
                              prepend-icon="mdi-home-city"
                              item-text="name"
                              item-value="id"
                              :label="$t('Fraccionamientos')"
                              :filter="customFilter"
                              :error-messages="errores.idHousingUnit"
                              :items="housing_units"
                              no-data-text="Ningún Resultado"
                              clearable
                              outlined
                              autocomplete="off"
                          >
                            <template v-slot:selection="data">
                              <v-chip
                                  v-bind="data.attrs"
                                  :input-value="data.selected"
                                  @click="data.select"
                              >
                                <v-avatar left>
                                  <v-img :src="data.item.logo"></v-img>
                                </v-avatar>
                                {{ data.item.name }}
                              </v-chip>
                            </template>
                            <template v-slot:item="data">
                              <template v-if="typeof data.item !== 'object'">
                                <v-list-item-content v-text="data.item"></v-list-item-content>
                              </template>
                              <template v-else>
                                <v-list-item-avatar>
                                  <img :src="data.item.logo">
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap class="my-4" align-center justify-center fill-height>
                        <v-flex xs12 sm3 class="text-center">
                          <v-menu
                              v-model="calendario"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  v-model="computedInitialDateFormatted"
                                  :label="$t('Fecha')"
                                  hint="DD/MM/YYYY"
                                  persistent-hint
                                  prepend-icon="mdi-calendar"
                                  name="date"
                                  readonly
                                  v-on="on"
                                  :error-messages="errores.date"
                                  outlined
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                :locale="$t('region')"
                                v-model="date"
                                @input="calendario = false">
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12 sm3 class="text-center">
                          <v-menu
                              v-model="calendario2"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                  v-model="computedFinalDateFormatted"
                                  prepend-icon="mdi-calendar"
                                  name="date2"
                                  :label="$t('finalDate')"
                                  readonly
                                  hint="DD/MM/YYYY"
                                  persistent-hint
                                  v-on="on"
                                  :error-messages="errores.date2"
                                  outlined
                              ></v-text-field>
                            </template>
                            <v-date-picker
                                :locale="$t('region')"
                                v-model="date2"
                                @input="calendario2 = false">
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <br>
                      </v-layout>
                      <v-layout row wrap class="my-4" align-center justify-center fill-height>
                        <v-flex xs12 sm3 class="text-center">
                          <v-btn
                              :disabled="id_empresa === undefined"
                              color="primary"
                              type="submit"
                              large
                          >{{ $t('Filtrar') }}
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-form>
                    <v-layout row wrap class="my-4" align-center justify-center fill-height>
                      <v-flex xs12>
                        <v-btn
                          v-show="selected.length > 0"
                          color="red"
                          block
                          @click="deleteDialog = true"
                        >
                          {{$t('eliminar')}} ({{selected.length}})
                        </v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-btn
                            v-show="accessWithoutCode.length > 0"
                            color="primary"
                            @click="exportPdfAccessNoCode"
                        >
                          {{$t('export_to_pdf')}}
                        </v-btn>
                        <v-data-table
                            v-model="selected"
                            show-select
                            item-key="id"
                            :headers="headersAccessWithoutCode"
                            :loading="loadingDataAccessWithoutCode"
                            :items="accessWithoutCode"
                            :search="searchAccessNoCode"
                            :footer-props="{
                                itemsPerPageOptions: [
                                    {text: '500', value: 500},
                                    {text: '1000', value: 1000},
                                    {text: this.$t('todos'), value: -1}
                                ],
                                itemsPerPageText: $t('filas_por_pagina')
                            }"
                            class="elevation-1"
                            :no-data-text="$t('no_registros_accesos')"
                        >
                          <template v-if="getProfile.role === 4" v-slot:item.dateTime_ExitAccess="{ item }">
                            <div v-if="item.dateTime_ExitAccess === null">
                              <v-btn
                                  @click="firmar(item.id)"
                                  color="primary">
                                {{$t('firmar')}}
                              </v-btn>
                            </div>
                            <div v-else>
                              {{item.dateTime_ExitAccess}}
                            </div>
                          </template>
                          <template v-else  v-slot:item.dateTime_ExitAccess="{ item }">
                            {{ item.dateTime_ExitAccess == null ? $t('pendiente')  : item.dateTime_ExitAccess }}
                          </template>
                          <template v-slot:items="props">
                            <td>{{ props.item.dateTime_EntranceAccess }}</td>
                          </template>
                          <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('Accesos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapGetters } from 'vuex'
import JSPDF from 'jspdf'
import 'jspdf-autotable'

export default {
  name: 'historical_superadmin',
  data: () => ({
    id_empresa: undefined,
    housing_units: [],
    selected: [],
    deleteDialog: false,
    calendario: '',
    date: '',
    calendario2: '',
    date2: '',
    errores: [],
    fecha_actual: '',
    yyyy: '',
    mm: '',
    dd: '',
    yyyy2: '',
    mm2: '',
    dd2: '',
    loading_si: false,
    headersAccessWithoutCode: [],
    loadingDataAccessWithoutCode: false,
    accessWithoutCode: [],
    infoAccessWithoutCode: '',
    searchAccessNoCode: '',
    idHouse: null,
    houses: []
  }),
  created () {
    this.getHousingUnits()
    this.fecha_actual = this.get_current_date()
    this.date = this.fecha_actual
    this.date2 = this.fecha_actual
    if (this.getProfile.role === 1 || this.getProfile.role === 4) {
      this.getHouses()
    }
    this.get_all_access_without_code(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
  },
  beforeUpdate () {
    this.headersAccessWithoutCode = [
      {
        text: this.$t('Visitante'),
        align: 'center',
        sortable: false,
        value: 'name_guest'
      },
      {
        text: this.$t('hora_acceso'),
        align: 'center',
        sortable: true,
        value: 'dateTime_EntranceAccess'
      },
      {
        text: this.$t('hora_salida'),
        align: 'center',
        sortable: true,
        value: 'dateTime_ExitAccess'
      },
      {
        text: this.$t('Notas'),
        align: 'center',
        sortable: true,
        value: 'comments'
      }
    ]
  },
  computed: {
    ...mapGetters(['getProfile']),
    computedInitialDateFormatted () {
      return this.formatDate(this.date)
    },
    computedFinalDateFormatted () {
      return this.formatDate(this.date2)
    }
  },
  methods: {
    getHousingUnits () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/housing_unit/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.housing_units = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getHouses: function () {
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/house/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.houses = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    customFilter (item, queryText) {
      const textOne = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    example: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number),
    customFilterHouse (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    get_current_date () {
      var today = new Date()
      this.dd = today.getDate()
      this.mm = today.getMonth() + 1
      this.yyyy = today.getFullYear()
      this.dd2 = today.getDate()
      this.mm2 = today.getMonth() + 1
      this.yyyy2 = today.getFullYear()

      if (this.dd < 10) {
        this.dd = '0' + this.dd
      }
      if (this.dd2 < 10) {
        this.dd2 = '0' + this.dd2
      }
      if (this.mm < 10) {
        this.mm = '0' + this.mm
      }
      if (this.mm2 < 10) {
        this.mm2 = '0' + this.mm2
      }
      today = this.yyyy + '-' + this.mm + '-' + this.dd
      return today
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    submit () {
      console.log('fraccionamiento = ', this.id_empresa)
      console.log('selected: ', this.selected)
      this.split_date(this.date, this.date2)
      this.get_all_access_without_code(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    },
    split_date (date, date2) {
      var arr = date.split('-')
      var arr2 = date2.split('-')

      this.yyyy = arr[0]
      this.mm = arr[1]
      this.dd = arr[2]

      this.yyyy2 = arr2[0]
      this.mm2 = arr2[1]
      this.dd2 = arr2[2]
    },
    get_all_access_without_code (yyyy, mm, dd, yyyy2, mm2, dd2) {
      this.loadingDataAccessWithoutCode = true
      const config = {
        method: 'get',
        url: 'https://clubtest.intrare.app/access_no_code_create_get/' + this.id_empresa + '/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.data === 204) {
            this.accessWithoutCode = []
          } else {
            this.accessWithoutCode = response.data
            this.accessWithoutCode = this.accessWithoutCode.reverse()
            console.log(this.access)
          }
          this.loadingDataAccessWithoutCode = false
        })
        .catch(error => {
          this.loadingDataAccessWithoutCode = false
          console.log(error)
        })
    },
    deleteRecordsSelected () {
      this.loading_si = true
      let records = []
      for (let i = 0; i < this.selected.length; i++) {
        records.push({
          'id': this.selected[i].id
        })
      }
      console.log(records)
      const config = {
        method: 'delete',
        url: 'https://clubtest.intrare.app/access_no_code/delete/list',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: records
      }
      axios(config).then(ok => {
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_accessnocode_baja'))
        setTimeout(this.clear, 3000)
        this.loading_si = false
        this.deleteDialog = false
        this.get_all_access_without_code(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
      }).catch(error => {
        this.loading_si = false
        this.deleteDialog = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
      this.selected = []
    },
    exportPdfAccessNoCode () {
      var fechaInicial = this.formatDate(this.date)
      var fechaFinal = this.formatDate(this.date2)
      var headerInvitationSent = this.$t('access_report_no_code')
      var period = this.$t('period')
      var al = this.$t('al')
      var page = this.$t('page')
      var de = this.$t('de')
      // var headerDate = this.$t('fecha_hora')
      var columns = [{
        name_guest: this.$t('Visitante'),
        dateTime_EntranceAccess: this.$t('hora_acceso'),
        dateTime_ExitAccess: this.$t('hora_salida'),
        comments: this.$t('Notas')
      }]
      var doc = new JSPDF('portrait', 'pt', 'letter')
      var totalPagesExp = '{total_pages_count_string}'
      doc.autoTable({
        head: columns,
        body: this.accessWithoutCode,
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(20)
          doc.setTextColor(40)
          doc.setFontStyle('normal')
          // if (base64Img) {
          //     doc.addImage(base64Img, 'JPEG', data.settings.margin.left, 15, 10, 10)
          // }
          doc.text(headerInvitationSent, data.settings.margin.left + 20, 38)
          doc.text(period + fechaInicial + al + fechaFinal, data.settings.margin.left + 20, 60)

          // Footer
          var str = page + doc.internal.getNumberOfPages()
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === 'function') {
            str = str + de + totalPagesExp
          }
          doc.setFontSize(10)

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize
          var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
          doc.text(str, data.settings.margin.left, pageHeight - 10)
        },
        allSectionHooks: true,
        // didParseCell: function (data) {
        //   if (data.row.section === 'body') {
        //     if (data.column.index === 3) {
        //       if(data.cell.text.toString() !== headerDate) {
        //         const [day, month, year] = data.cell.text.toString().split('-')
        //         data.cell.text = `${day}/${month}/${year}`
        //       }
        //     }
        //   }
        // },
        margin: { top: 80 }
      })
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp)
      }
      doc.save('accessNoCode' + '_' + this.date + '_' + this.date2 + '.pdf')
    }
  }
}
</script>
